// DIN 1355
export let dateToStringShort = function (dt) {
    return kendo.toString(dt, "MMM yyyy")
};
export let stringToDateSolr = function (str) {
    return kendo.parseDate(str, "yyyy-MM-dd'T'HH:mm:fff'Z'")
};
export let dateToStringSolr = function (dt) {
    return kendo.toString(dt, "yyyy-MM-dd'T'HH:mm:ss.fff'Z'");
};

// Escape special characters
export let escapeForSolr = function (text) {
    return text.replace(/(\+|-|!|\(|\)|\{|\}|\[|\]|\^|"|~|\*|\?|:|\\|&&|\|\|)/g, function (match) {
        return '\\' + match;
    });
};

// Unescape escaped special characters
export let unescapeForSolr = function (text) {
    return text.replace(/(\\\+|\\-|\\!|\\\(|\\\)|\\\{|\\\}|\\\[|\\\]|\\\^|\\"|\\~|\\\*|\\\?|\\:|\\\\|\\&&|\\\|\|)/g, function (match) {
        return match.substring(1);
    });
};

export let getGroupingOptions = function (facetName, options) {
    let groupingOptions = [];
    if (options) {
        for (let key in options) {
            if (options.hasOwnProperty(key)) {
                if (!(/^groupingregex\.[a-zA-Z0-9]+/.test(key)))
                    continue;

                let regex = options[key];
                if (regex.substring(0, 1) === '/') {
                    regex = regex.substring(1);
                }
                if (regex.substring(regex.length - 1) === '/') {
                    regex = regex.substring(0, regex.length - 1);
                }

                let textKey = key.substring(14);
                let defText = options["groupingdefault." + textKey];
                groupingOptions.push({
                    regex: new RegExp(regex),
                    textKey: facetName + "." + textKey,
                    defaultText: defText || textKey
                });
            }
        }
    }
    return groupingOptions;
}
